export default function parseLanguage(text, language) {
  const str = text != null ? `${text}` : text;
  if (str && str.includes('|~|')) {
    const [text_zh, text_en] = str.split('|~|');
    return language && language === 'en' ? text_en : text_zh;
  } else {
    return str;
  }
}
